document.addEventListener('DOMContentLoaded', initForm)

const eventShowError = new CustomEvent('error', {bubbles: true})
const eventHideError = new CustomEvent('valid', {bubbles: true})

const regexp = {
    email() {
        return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    }
}

const isDomElement = (element) => {
    return element instanceof Element
}

const moonValid = {
    isLength(input) {
        if (!isDomElement(input)) {
            return true
        }

        return input.value.length > 4
    },
    isLengthArticle(input) {
        if (!isDomElement(input)) {
            return true
        }

        return input.value.length > 150
    },
    isChecked(input) {
        if (!isDomElement(input)) {
            return true
        }

        return input.checked
    },
    isEmail(input) {
        if (!isDomElement(input)) {
            return true
        }

        return regexp.email().test(input.value)
    },
    isFile(input) {
        if (!isDomElement(input)) {
            return true
        }

        return input.files[0]
    }
}

const checkbox = {
    showError: (input) => {
        if (!isDomElement(input)) {
            return
        }

        input.dispatchEvent(eventShowError)
    },
    hideError: (input) => {
        if (!isDomElement(input)) {
            return
        }

        input.dispatchEvent(eventHideError)
    },
    reset(input) {
        if (!isDomElement(input)) {
            return
        }

        input.checked = false
    }
}

const input = {
    showError(input) {
        if (!isDomElement(input)) {
            return
        }

        input.dispatchEvent(eventShowError)
    },
    hideError(input) {
        if (!isDomElement(input)) {
            return
        }

        input.dispatchEvent(eventHideError)
    },
    reset(input) {
        if (!isDomElement(input)) {
            return
        }

        input.value = ''
    }
}


function initForm() {

    const form = document.querySelector('.form-body')
    const dropDown = document.querySelector('.ui-dropdown__panel')

    const checkBoxFirst = document.querySelector(`[data-id="brand-name-first"]`)
    const checkBoxSec = document.querySelector(`[data-id="brand-name-second"]`)
    const checkBoxThird = document.querySelector(`[data-id="brand-name-third"]`)
    const phoneNumber = document.querySelector(`[data-id="phone"]`)
    const mail = document.querySelector(`[data-id="mail"]`)
    const newsName = document.querySelector(`[data-id="news-name"]`)
    const newsArticleMain = document.querySelector(`[data-id="news-article-main"]`)
    const privacyPolicy = document.querySelector(`[data-id="checkbox-privacy"]`)

    const file = document.querySelector(`[data-id="file"]`)
    const fileBox = document.querySelector(`[data-id="file-label"]`)
    const fileCustom = document.querySelector(`[data-id="file-custom"]`)
    const fileUrl = document.querySelector(`[data-id="file-url"]`)

    const jurName = document.querySelector(`[data-id="jur-name"]`)
    const innNumber = document.querySelector(`[data-id="inn-number"]`)
    const bannerName = document.querySelector(`[data-id="banner-name"]`)
    const price = document.querySelector(`[data-id="price"]`)
    const shortComp = document.querySelector(`[data-id="short-comp"]`)
    const fullComp = document.querySelector(`[data-id="full-comp"]`)
    const availableFrom = document.querySelector(`[data-id="available-from"]`)
    const availableTo = document.querySelector(`[data-id="available-to"]`)
    const priceAmount = document.querySelector(`[data-id="price-amount"]`)
    const limitForOne = document.querySelector(`[data-id="limit-for-one"]`)
    const repaymentMethod = document.querySelector(`[data-id="repayment-method"]`)

    initElementsForm(form)

    const hideAllError = () => {
        input.hideError(newsName)
        input.hideError(phoneNumber)
        input.hideError(mail)
        input.hideError(newsArticleMain)
        input.hideError(file)

        input.hideError(fileUrl)
        input.hideError(jurName)
        input.hideError(innNumber)
        input.hideError(bannerName)
        input.hideError(price)
        input.hideError(shortComp)
        input.hideError(fullComp)
        input.hideError(availableFrom)
        input.hideError(availableTo)
        input.hideError(priceAmount)
        input.hideError(limitForOne)
        input.hideError(repaymentMethod)

        checkbox.hideError(privacyPolicy)
    }

    form.addEventListener('submit', (event) => {
        event.preventDefault()

        const isError = [
            !moonValid.isLength(newsName) && input.showError(newsName),
            !moonValid.isLength(phoneNumber) && input.showError(phoneNumber),
            !moonValid.isEmail(mail) && input.showError(mail),
            !moonValid.isLengthArticle(newsArticleMain) && input.showError(newsArticleMain),

            !moonValid.isFile(file) && input.showError(fileBox),

            !moonValid.isLength(jurName) && input.showError(jurName),
            !moonValid.isLength(innNumber) && input.showError(innNumber),
            !moonValid.isLength(bannerName) && input.showError(bannerName),
            !moonValid.isLength(price) && input.showError(price),
            !moonValid.isLength(shortComp) && input.showError(shortComp),
            !moonValid.isLengthArticle(fullComp) && input.showError(fullComp),
            !moonValid.isLength(availableFrom) && input.showError(availableFrom),
            !moonValid.isLength(availableTo) && input.showError(availableTo),
            !moonValid.isLength(priceAmount) && input.showError(priceAmount),
            !moonValid.isLength(limitForOne) && input.showError(limitForOne),
            !moonValid.isLength(repaymentMethod) && input.showError(repaymentMethod),
            !moonValid.isFile(fileCustom) && input.showError(fileUrl),

            !moonValid.isChecked(privacyPolicy) && checkbox.showError(privacyPolicy)
        ].some((valid) => valid === null || valid === undefined)

        const isErrorChecked = [
            !moonValid.isChecked(checkBoxFirst),
            !moonValid.isChecked(checkBoxSec),
            !moonValid.isChecked(checkBoxThird)
        ].some((valid) => valid === false)

        if (!isErrorChecked) {
            dropDown.classList.add('ui-dropdown__panel--error')
        }

    })

    form.addEventListener('input', () => {
        dropDown.classList.remove('ui-dropdown__panel--error')

        hideAllError()
    })
}


function initElementsForm(form) {
    const listInput = form.querySelectorAll('.form-body__input')
    const listCheckbox = form.querySelectorAll('.ui-checkbox')

    for (const input of listInput) {
        input.addEventListener('error', () => {
            input.classList.add('form-body__input--border')
        })

        input.addEventListener('valid', () => {
            input.classList.remove('form-body__input--border')
        })
    }

    for (const checkbox of listCheckbox) {
        checkbox.addEventListener('error', () => {
            checkbox.classList.add('ui-checkbox--error')
        })

        checkbox.addEventListener('valid', () => {
            checkbox.classList.remove('ui-checkbox--error')
        })
    }
}
